import { useId } from 'react'

import { useParams, useNavigate } from 'react-router-dom'

import { AssignmentForm } from '@containers/Forms/Assignment'
import { TAssignmentForm } from '@containers/Forms/Assignment/schema'
import { useAlerts } from '@hooks/alerts'

import { useAddTaskContext } from '../AddTaskContext'

export function AddDummyAssignmentFormScreen() {
  const { showDismissAlert } = useAlerts()
  const navigate = useNavigate()
  const dummyAssignmentId = useId()
  const { assignmentsData, setAssignmentsData } = useAddTaskContext()

  const { duration } = useParams<{ duration: string }>()

  const initialTask = {
    code: '',
    startTime: new Date(new Date().setHours(9, 0, 0, 0)),
    duration: Number(duration),
  }

  function handleAddAssignment(assignment: TAssignmentForm) {
    if (assignment) {
      const completeAssignment = {
        ...assignment,
        dummyAssignmentId,
      }

      setAssignmentsData([...assignmentsData, completeAssignment])
      navigate(-1)
    }
  }

  function handleShowAlertOnAssignmentDismiss() {
    showDismissAlert(() => navigate(-1))
  }

  return (
    <AssignmentForm
      onSave={handleAddAssignment}
      onClose={handleShowAlertOnAssignmentDismiss}
      task={initialTask}
      title="Add Resource"
    />
  )
}
